import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Card, Table, Input, Button, Row, Col } from 'antd'

import { tableColumns } from '../../dataTypes/rooms'
import { requestRoomsList, requestDeleteRoom } from '../../redux/Rooms/actions'

import ModalButtonCreateChannel from './ModalButtonCreateChannel'

class Channels extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            roomSearch: ''
        }
        this.handleChange = this.handleChange.bind(this)
    }

    componentDidMount() {
        const { requestRoomsList } = this.props

        requestRoomsList()
    }

    onChangePage = page => {
        const { requestRoomsList } = this.props

        requestRoomsList(page, this.state.roomSearch)
    }

    searchRoom = () => {
        const { requestRoomsList } = this.props

        requestRoomsList(1, this.state.roomSearch)
    }

    handleChange = event => {
        this.setState({ roomSearch: event.target.value })
    }

    handleDelete = roomId => {
        const { requestDeleteRoom } = this.props

        requestDeleteRoom({ roomId, filter: this.state.roomSearch })
    }

    render() {
        const {
            roomsList,
            pagination: { page_size, page_number, total_entries }
        } = this.props

        return (
            <Card title="Channels Table">
                <div>
                    <Row type="flex">
                        <Col lg={8} md={12} xs={24}>
                            <Input
                                placeholder="Channel ID"
                                onChange={this.handleChange}
                                value={this.state.roomSearch}
                                onPressEnter={this.searchRoom}
                            />
                        </Col>
                        <Col lg={4} md={6} xs={12}>
                            <Button type="primary" onClick={this.searchRoom}>
                                Search
                            </Button>
                        </Col>
                        <Col lg={4} md={6} xs={12}>
                            <ModalButtonCreateChannel />
                            {/* <Button type="primary" onClick={this.searchRoom}>
                                Create
                            </Button> */}
                        </Col>
                    </Row>
                </div>
                <Table
                    className="gx-table-responsive"
                    columns={tableColumns({
                        handleDelete: this.handleDelete
                    })}
                    dataSource={roomsList}
                    bordered
                    rowKey={record => record.room_id}
                    pagination={{
                        onChange: this.onChangePage,
                        pageSize: page_size,
                        current: page_number,
                        total: total_entries
                    }}
                />
            </Card>
        )
    }
}

const mapStateToProps = state => ({
    roomsList: state.rooms.list,
    pagination: state.rooms.pagination
})

const mapActionsToProps = dispatch => ({
    requestRoomsList: bindActionCreators(requestRoomsList, dispatch),
    requestDeleteRoom: bindActionCreators(requestDeleteRoom, dispatch)
})

export default connect(
    mapStateToProps,
    mapActionsToProps
)(Channels)
